import { render } from "./TrabajosRealizados.vue?vue&type=template&id=a8c7c91a"
import script from "./TrabajosRealizados.vue?vue&type=script&lang=js"
export * from "./TrabajosRealizados.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__